import { render, staticRenderFns } from "./glWebCall.vue?vue&type=template&id=8b3d8bc6&scoped=true"
import script from "./glWebCall.vue?vue&type=script&lang=js"
export * from "./glWebCall.vue?vue&type=script&lang=js"
import style0 from "./glWebCall.vue?vue&type=style&index=0&id=8b3d8bc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3d8bc6",
  null
  
)

export default component.exports